import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL
const getUser = async (offset = 0, itemsPerPage = 0, activePage = 0, params = 0) => {
  const response = await agent.get(
    `${API_URL}users/listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const getRank = async (roundId = 0) => {
  const response = await agent.get(`${API_URL}users/getRank?roundId=${roundId}`)
  return response.data
}
const getAdminUserListing = async (
  offset = 0,
  itemsPerPage = 0,
  activePage = 0,
  params = 0,
  adminTabActive = 0,
  userTabActive = 0,
) => {
  const response = await agent.get(
    `${API_URL}users/getAdminUserListing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&adminTabActive=${adminTabActive}&userTabActive=${userTabActive}&${params}`,
  )
  return response.data
}
const hubUserListing = async (offset = 0, itemsPerPage = 0, activePage = 0, params = 0) => {
  const response = await agent.get(
    `${API_URL}users/hubUserListing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const getMctGameListing = async (offset = 0, itemsPerPage = 0, activePage = 0, params = 0) => {
  const response = await agent.get(
    `${API_URL}users/getMctGameListing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}

const getTeamMember = async (offset = 0, itemsPerPage = 0, activePage = 0, params = 0) => {
  const response = await agent.get(
    `${API_URL}users/getTeamMember?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const getGamePayment = async () => {
  const response = await agent.get(`${API_URL}users/getGamePayment`)
  return response.data
}
const saveUser = async (data) => {
  const response = await agent.post(API_URL + 'users/save-user', data)
  return response.data
}

const editUser = async (data) => {
  const response = await agent.post(API_URL + 'users/edit-user', data)
  return response.data
}
const getUserDetail = async (id) => {
  const response = await agent.get(`${API_URL}users/user-details/${id}`)
  return response.data
}

const deleteUser = async (data) => {
  const response = await agent.post(API_URL + 'users/delete-user', data)
  return response.data
}

const userData = async (data) => {
  const response = await agent.get(`${API_URL}users/user-data`)
  return response.data
}
const markAsPaidOrUnPaid = async (roleId, userId, status, type) => {
  const response = await agent.get(
    `${API_URL}users/update-paid-status/${roleId}/${userId}/${status}/${type}`,
  )
  return response.data
}
const paidUserListing = async (roleId, id, status) => {
  const response = await agent.get(`${API_URL}users/paid-user-listing`)
  return response.data
}
const getGameUser = async (accountId) => {
  const response = await agent.get(`${API_URL}users/getGameUser/${accountId}`)
  return response.data
}
const suspendMember = async (userId = '', status = '') => {
  const response = await agent.get(`${API_URL}users/suspendMember/${userId}/${status}`)
  return response.data
}
const markAsActiveGame = async (data) => {
  const response = await agent.post(API_URL + 'users/markAsActiveGame', data)
  return response.data
}
const changeAccountStatus = async (data) => {
  const response = await agent.post(API_URL + 'users/changeAccountStatus', data)
  return response.data
}

const membershipListing = async (offset = 0, itemsPerPage = 0, activePage = 0, params = 0) => {
  const response = await agent.get(
    `${API_URL}users/manageMembership?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const membershipMemeber = async (offset = 0, itemsPerPage = 0, activePage = 0, params = 0) => {
  const response = await agent.get(
    `${API_URL}users/membershipMemeber?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const changeMembership = async (data) => {
  const response = await agent.post(`${API_URL}users/updateMembershipStatus`, data)
  return response.data
}

const deleteMembershipByAdmin = async (userId) => {
  const response = await agent.get(`${API_URL}users/deleteMembershipByAdmin/${userId}`)
  return response.data
}

const getGameDetails = async (id) => {
  const response = await agent.get(`${API_URL}users/getGameDetails/${id}`)
  return response.data
}

const getMctGameAccord2Listing = async (
  offset = 0,
  itemsPerPage = 0,
  activePage = 0,
  params = 0,
) => {
  const response = await agent.get(
    `${API_URL}users/getMctGameAccord2Listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const getMctGameAccord4Listing = async (
  offset = 0,
  itemsPerPage = 0,
  activePage = 0,
  params = 0,
) => {
  const response = await agent.get(
    `${API_URL}users/getMctGameAccord4Listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const getMctGameAccord3Listing = async (
  offset = 0,
  itemsPerPage = 0,
  activePage = 0,
  params = 0,
) => {
  const response = await agent.get(
    `${API_URL}users/getMctGameAccord3Listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const getMctGameAccord5Listing = async (
  offset = 0,
  itemsPerPage = 0,
  activePage = 0,
  params = 0,
) => {
  const response = await agent.get(
    `${API_URL}users/getMctGameAccord5Listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const getMctGameAccord6Listing = async (
  offset = 0,
  itemsPerPage = 0,
  activePage = 0,
  params = 0,
) => {
  const response = await agent.get(
    `${API_URL}users/getMctGameAccord6Listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}

const getMemberCsvData = async (id) => {
  const response = await agent.get(`${API_URL}getMemberCsvData`)
  return response.data
}

const adminPricingPlanUsers = async (offset = 0, itemsPerPage = 0, activePage = 0, params = 0) => {
  const response = await agent.get(
    `${API_URL}adminPricingPlanUsers?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const loginUserList = async (offset, limit, page, params) => {
  const response = await agent.get(
    API_URL + `loginUserList?offset=${offset}&limit=${limit}&page=${page}&${params}`,
  )

  return response.data
}
const memberLoginHistory = async (userId) => {
  const response = await agent.get(API_URL + `memberLoginHistory/${userId}`)

  return response.data
}

const UserService = {
  suspendMember,
  getUser,
  markAsActiveGame,
  getTeamMember,
  saveUser,
  deleteUser,
  getUserDetail,
  editUser,
  userData,
  markAsPaidOrUnPaid,
  paidUserListing,
  getAdminUserListing,
  getGameUser,
  changeAccountStatus,
  getRank,
  changeMembership,
  membershipListing,
  membershipMemeber,
  getGamePayment,
  getMctGameListing,
  getGameDetails,
  getMctGameAccord2Listing,
  getMctGameAccord3Listing,
  getMctGameAccord4Listing,
  getMctGameAccord5Listing,
  getMctGameAccord6Listing,
  getMemberCsvData,
  adminPricingPlanUsers,
  deleteMembershipByAdmin,
  hubUserListing,
  loginUserList,
  memberLoginHistory,
}

export default UserService
